import { Capacitor } from '@capacitor/core'

/** True inside the iOS/Android app (Capacitor WebView). */
export const isNative = Capacitor.isNativePlatform()
export const platform = Capacitor.getPlatform() as 'web' | 'ios' | 'android'

/**
 * Where the API lives. The web app is served by the same origin as the API, so it uses relative
 * URLs. The native app's WebView origin is capacitor://localhost (iOS) or https://localhost
 * (Android), so it calls the API by absolute URL, set at build time.
 */
export const apiOrigin: string = isNative
  ? (import.meta.env.VITE_API_ORIGIN ?? 'https://hugo.beyonityhello.com').replace(/\/+$/, '')
  : ''

export function apiUrl(path: string): string {
  return `${apiOrigin}${path}`
}

/** Test-only native sign-in without Google, enabled only in local debug builds. */
export const nativeDebug = isNative && import.meta.env.VITE_NATIVE_DEBUG === 'true'
